import { createApp } from 'vue'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Toaster from '@meforma/vue-toaster';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/scss/custom.scss';
import 'nprogress/nprogress.css';
import LoadScript from "vue-plugin-load-script";
import { Popover } from 'bootstrap';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate, {
    auto: true,
});
import App from '@/customer/App.vue';
import router from '@/customer/router';
import { useAppStore } from '@/stores/appstore';
import loader from "vue3-ui-preloader";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import filters from '@/utilities/filters.js';



// Import the CSS or use your own!
import "vue3-ui-preloader/dist/loader.css"

const app = createApp(App);
app.use(Toaster , { 
    position: "top-right"
});
app.use(pinia);
app.use(router);
app.use(LoadScript);

app.component('loader', loader);
app.directive('popover', {
    mounted(el) {
        new Popover(el);
    },
    updated(el) {
        const existingPopover = Popover.getInstance(el);
        if (existingPopover) {
            existingPopover.dispose();
        }
        new Popover(el);
    }
});


app.mount('#customer-app');

app.config.globalProperties.$filters = filters;
